import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { createFlightBookingPaymentIntentApi } from './createFlightBookingPaymentIntent.api'
import createFlightBookingPaymentIntentInitialState from './createFlightBookingPaymentIntent.initialState'
import {
  CreateFlightBookingPaymentIntentErrorResponse,
  CreateFlightBookingPaymentIntentRequestPayload
} from './createFlightBookingPaymentIntent.types'

export const createFlightBookingPaymentIntent = createAsyncThunk(
  urls.payments.createFlightBookingPaymentIntent,
  async (payload: CreateFlightBookingPaymentIntentRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await createFlightBookingPaymentIntentApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const createFlightBookingPaymentIntentSlice = createSlice({
  name: urls.payments.createFlightBookingPaymentIntent,
  initialState: createFlightBookingPaymentIntentInitialState,
  reducers: {
    resetCreateFlightBookingPaymentIntent: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createFlightBookingPaymentIntent.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(createFlightBookingPaymentIntent.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(createFlightBookingPaymentIntent.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as CreateFlightBookingPaymentIntentErrorResponse
        state.success = null
      })
  }
})

export const { actions: createFlightBookingPaymentIntentActions, reducer: createFlightBookingPaymentIntentReducer } =
  createFlightBookingPaymentIntentSlice
export const { resetCreateFlightBookingPaymentIntent } = createFlightBookingPaymentIntentActions
export default createFlightBookingPaymentIntentSlice.reducer
